module.exports = __webpack_public_path__ + "static/iconography-68d43375dfdd279aed379a2d379ab7a0.png";